import { Avatar, Button, Menu, Tooltip } from "antd";
import { LogoutOutlined, MoonOutlined, SunOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { BrandMark } from "./BrandMark";
import { NAV_ITEMS, SETTINGS_ITEM } from "./NavItems";
import { isNavSelected } from "./navMatch";
import { useColorMode } from "../theme/ThemeProvider";
import { useAuth } from "../hooks/useAuth";

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { mode, toggle } = useColorMode();
  const { user, logout } = useAuth();

  const items = [...NAV_ITEMS, SETTINGS_ITEM].map((it) => ({
    key: it.to,
    icon: it.icon,
    label: it.label,
  }));

  const selected = [...NAV_ITEMS, SETTINGS_ITEM]
    .filter((it) => isNavSelected(it.to, location.pathname, location.search))
    .map((it) => it.to);

  return (
    <aside
      style={{
        width: 240,
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid var(--ant-color-border)",
        background: "var(--ant-color-bg-container)",
        padding: "16px 12px",
      }}
    >
      <div style={{ padding: "8px 8px 16px" }}>
        <BrandMark />
      </div>
      <Menu
        mode="inline"
        selectedKeys={selected}
        items={items}
        onClick={(e) => navigate(String(e.key))}
        style={{ borderInlineEnd: "none", flex: 1, background: "transparent" }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: 8,
          borderTop: "1px solid var(--ant-color-border)",
        }}
      >
        <Avatar src={user?.pictureUrl ?? undefined} icon={<UserOutlined />} size={32} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 15,
              fontWeight: 500,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {user?.name ?? user?.email ?? "—"}
          </div>
          <div
            style={{
              fontSize: 13,
              color: "var(--ant-color-text-secondary)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {user?.email}
          </div>
        </div>
        <Tooltip title={mode === "dark" ? "切到浅色" : "切到深色"}>
          <Button
            type="text"
            shape="circle"
            icon={mode === "dark" ? <SunOutlined /> : <MoonOutlined />}
            onClick={toggle}
          />
        </Tooltip>
        <Tooltip title="退出">
          <Button
            type="text"
            shape="circle"
            icon={<LogoutOutlined />}
            onClick={() => {
              void logout();
            }}
          />
        </Tooltip>
      </div>
    </aside>
  );
}
